import './footer-banner.scss';
import './import/footer-banner.png';
